<template>
    <div class="pdf-viewer">
        <v-card>
            <v-card-title>
                <h2>Guide utilisateur GNC</h2>
                <v-spacer></v-spacer>
                <v-btn icon @click="closePdf">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <div class="pdf-container">
                    <iframe
                        :src="pdfUrl"
                        width="100%"
                        height="600px"
                        frameborder="0"
                        style="border-radius: 4px;"
                    >
                        <p>Votre navigateur ne supporte pas l'affichage des PDF intégrés.</p>
                        <p><a :href="pdfUrl" target="_blank">Cliquez ici pour ouvrir le PDF</a></p>
                    </iframe>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'PdfViewer',
    props: {
        pdfUrl: {
            type: String,
            required: true
        }
    },
    methods: {
        closePdf() {
            this.$emit('close');
        }
    }
}
</script>

<style scoped>
.pdf-viewer {
    max-width: 100%;
}

.pdf-container {
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
}
</style>